import React, { createContext, useContext, useState } from 'react';
import { translateDOM } from '../translateDOM';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en'); 

  const changeLanguage = async (lang) => {
    setLanguage(lang);
    await translateDOM(lang); 
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
